import { isIssuerSupported, issuerDefinitions } from '@/constants/issuers';

import { IssuerAvatar } from '@/ui/Avatars/IssuerAvatar';
import { BadgeTooltip, type BadgeTooltipProps } from '@/ui/Badge/BadgeTooltip';

type TokenIssuerBadgeProps = {
  id?: string;
  size?: BadgeTooltipProps['size'];
  className?: string;
};

export const TokenIssuerBadge = ({ id, size = 'md', className }: TokenIssuerBadgeProps) => {
  const issuer = isIssuerSupported(id) ? issuerDefinitions[id] : undefined;
  const issuerName = issuer?.name ?? id ?? 'unknown';

  if (!issuer || issuer.hideBadge) {
    return null;
  }

  return (
    <BadgeTooltip
      name={issuerName}
      label={`Issuer: ${issuerName}`}
      tooltip={`Issued by ${issuerName}`}
      icon={<IssuerAvatar id={id ?? ''} alt="" size={size === 'sm' ? 10 : 16} />}
      size={size}
      className={className}
    />
  );
};
